// removed by extract-text-webpack-plugin
module.exports = {"articleHeaderTitle":"styles__articleHeaderTitle___2RFI2"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/articleHeaderTitle/styles.css
// module id = Kjq5
// module chunks = 3